export const BEFORE_SIGN_IN_PATH = '/login'
export const AFTER_SIGN_IN_PATH = '/home'

export type MailTokenResult = {
  mailToken: string
  passwordToken?: string
}
